export const FETCH_REFERRER_PATIENTS = 'src/ReferrerDashboard/FETCH_REFERRER_PATIENTS';
export const FETCH_REFERRER_PATIENTS_SUCCESS = 'src/ReferrerDashboard/FETCH_REFERRER_PATIENTS_SUCCESS';
export const FETCH_REFERRER_PATIENTS_ERROR = 'src/ReferrerDashboard/FETCH_REFERRER_PATIENTS_ERROR';

export const FETCH_REFERRER_PENDING = 'src/ReferrerDashboard/FETCH_REFERRER_PENDING';
export const FETCH_REFERRER_PENDING_SUCCESS = 'src/ReferrerDashboard/FETCH_REFERRER_PENDING_SUCCESS';
export const FETCH_REFERRER_PENDING_ERROR = 'src/ReferrerDashboard/FETCH_REFERRER_PENDING_ERROR';
